import { parse as parseQs } from "qs";
import React from "react";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import BatchDetailsComponent from "./components/BatchDetails";
import { BatchListUrlQueryParams } from "./urls";
import BatchListComponent from "./views/BatchList/";

const BatchList: React.FC = () => {
  const params = parseQs(location.search.substr(1));
  return <BatchListComponent params={params} />;
};

const BatchDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const qs = parseQs(location.search.substr(1));
  const params: BatchListUrlQueryParams = qs;

  return <BatchDetailsComponent id={decodeURIComponent(id)} params={params} />;
};

const Component = () => (
  <>
    <Routes>
      <Route path={""} element={<BatchList />} />
      <Route path={":id"} element={<BatchDetails />} />
    </Routes>
  </>
);

export default Component;
